import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse } from './../config';
import { ServerErrorMessagePipe } from './../pipe/server-error.pipe';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'wego-personprofile-failure',
  template: `
  <section class="content">
		<div class="col-md-12 text-center">
      <div class="panel panel-danger">
      <div class="panel-heading">
      {{ 'LblLinkExpired' | translate }}
      </div>
      <div class="panel-body"><p>
      {{ 'LblLinkExpiredMessage' | translate }}
                 <a routerLink="/">{{ 'LblHome' | translate }}</a> 
          </p></div>
    </div>
         
		</div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})

export class LinkExpiredComponent implements OnInit, OnDestroy {
  constructor() {

  }
  ngOnInit() {

  }
  ngOnDestroy() { console.log('ngOnDestroy'); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/link-expired.compontnet.ts